import { forwardRef, memo } from "react";
import { default as MaskedInput, MaskedInputProps } from "react-text-mask";
import createAutoCorrectedDatePipe from "text-mask-addons/dist/createAutoCorrectedDatePipe";

const autoCorrectedDatePipe = createAutoCorrectedDatePipe("HH:MM");

export type TimeFieldMaskRef = MaskedInput;
export type TimeFieldMaskProps = Omit<MaskedInputProps, "mask" | "pipe">;

export const TimeFieldMask = memo(forwardRef<TimeFieldMaskRef, TimeFieldMaskProps>((props, ref) =>
  <MaskedInput
    ref={ref}
    pipe={autoCorrectedDatePipe}
    mask={[ /\d/, /\d/, ":", /\d/, /\d/ ]}
    showMask
    {...props}
  />,
));

export default TimeFieldMask;
